/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiLineChartMouseScrollZoomPanMode {
	ENABLED, WITH_MODIFIER_KEY, DISABLED
}